import {
    Button,
    Dialog,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    Typography,
} from "@mui/material";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";

interface IProps {
  open: boolean;
  onClose: () => void;
  productParams?: any;
  platform?: string;
  setProductParams?: any;
}

const AuthModal = ({ open, onClose, productParams, platform, setProductParams }: IProps) => {
  const { enabledFeatures } = useContext(UserContext) as UserLoginInfo;

  const [settings, setSettings] = useState({
    feedbackType: "",
    type: "",
    url: "",
    authUser: "",
    authKey: "",
    interval: 1,
  });

  const navigate = useNavigate();

  const handleSystemTypeChange = (e: any, type: string) => {
    const { value } = e.target;

    setSettings({ ...settings, feedbackType: type, type: value });
  };

  const handleChange = (e: any, name: string) => {
    const { value } = e.target;
    setSettings({ ...settings, [name]: value });
  };

  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <Grid container p={3}>
          <Grid item xs={12}>
            <Typography>Authentication</Typography>
          </Grid>
          {/* <Grid item xs={12} mt={2}>
      <FormControl className="custom-select" fullWidth>
        <InputLabel>Choose your tracking system:</InputLabel>
        <Select
          value={settings.type}
          onChange={(e) =>
            handleSystemTypeChange(e, FEEDBACK_TYPE_AI_SUPPORT)
          }
        >
          <MenuItem key={TRACKING_SYSTEM_SELF} value={TRACKING_SYSTEM_SELF}>
            Cuvo Bugs Management System
          </MenuItem>
          {enableJira && enabledFeatures?.enableJira ? (
            <MenuItem
              key={TRACKING_SYSTEM_JIRA}
              value={TRACKING_SYSTEM_JIRA}
            >
              Jira System
            </MenuItem>
          ) : (
            ""
          )}
          {enableZendesk && enabledFeatures?.enableZendesk ? (
            <MenuItem
              key={TRACKING_SYSTEM_ZENDESK}
              value={TRACKING_SYSTEM_ZENDESK}
            >
              Zendesk System
            </MenuItem>
          ) : (
            ""
          )}
        </Select>
      </FormControl>
    </Grid> */}

          <Grid item xs={12} mt={2}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                The URl for your tracking/incident management system
                {/* <div
      style={{
        display: "inline-block",
        color: "red",
      }}
    >
      *
    </div>
    {fieldErrMsg.BUGS && fieldErrMsg.BUGS.trackingUrlErr ? (
      <div
        style={{
          display: "inline-block",
          color: "red",
        }}
      >
        {fieldErrMsg.BUGS.trackingUrlErr}
      </div>
    ) : (
      <></>
    )} */}
              </InputLabel>
              <OutlinedInput
                type="text"
                value={settings.url}
                onChange={(event) => handleChange(event, "url")}
                id="urlTracking-select"
                label="urlTracking" />
            </FormControl>
          </Grid>

          <Grid item xs={12} mt={2}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Provide auth user email for your tracking/incident management
                system
                {/* <div
      style={{
        display: "inline-block",
        color: "red",
      }}
    >
      *
    </div>
    {fieldErrMsg.BUGS && fieldErrMsg.BUGS.trackingUserErr ? (
      <div
        style={{
          display: "inline-block",
          color: "red",
        }}
      >
        {fieldErrMsg.BUGS.trackingUserErr}
      </div>
    ) : (
      <></>
    )} */}
              </InputLabel>
              <OutlinedInput
                type="text"
                value={settings.authUser}
                onChange={(event) => handleChange(event, "authUser")}
                id="emailTracking-select"
                label="emailTracking" />
            </FormControl>
          </Grid>

          <Grid item xs={12} mt={2}>
            <FormControl className="custom-select" fullWidth>
              <InputLabel>
                Provide auth key for your tracking/incident management system
                {/* <div
      style={{
        display: "inline-block",
        color: "red",
      }}
    >
      *
    </div>
    {fieldErrMsg.BUGS && fieldErrMsg.BUGS.trackingKeyErr ? (
      <div
        style={{
          display: "inline-block",
          color: "red",
        }}
      >
        {fieldErrMsg.BUGS.trackingKeyErr}
      </div>
    ) : (
      <></>
    )} */}
              </InputLabel>
              <OutlinedInput
                type="text"
                value={settings.authKey}
                onChange={(event) => handleChange(event, "authKey")}
                id="authTracking-select"
                label="authTracking" />
            </FormControl>
          </Grid>

          <Grid item xs={12} mt={2}>
            <FormControl fullWidth className="custom-select">
              <InputLabel id="demo-simple-select-label">Interval</InputLabel>
              <Select
                value={settings.interval}
                label="Interval"
                onChange={(event) => handleChange(event, "interval")}
              >
                <MenuItem value={1}>1 HOUR</MenuItem>
                <MenuItem value={2}>5 HOURS</MenuItem>
                <MenuItem value={3}>10 HOURS</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} mt={2}>
            <Button
              type="button"
              variant="outlined"
              sx={{
                textTransform: "uppercase",
                borderRadius: "24px",
              }}
            >
              Connect
            </Button>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default AuthModal;
